import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props extends React.PropsWithChildren {
  className?: string
}

export const MessageContainer: React.FC<Props> = ({ className, children }) => (
  <div className={clsJoin(css.message_container, className)}>{children}</div>
)
